module.exports = __webpack_public_path__ + "img/logo_made-in-germany.580ed29.svg";